export default __webpack_public_path__ + "static/media/google-play-badge.a7e8f353.svg";